import script from "./DynamicFormAttributes.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicFormAttributes.vue?vue&type=script&setup=true&lang=js"

import "./DynamicFormAttributes.vue?vue&type=style&index=0&id=44f691e6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f691e6"]])

export default __exports__